import {useCallback, useEffect, useState} from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../hooks/react-redux'

import {projectsSidebar} from './ProjectsSidebar.slices'

export function useProjectsSidebar(collapsed: boolean, toggleCollapseSidebar: () => void) {
  const dispatch = useAppDispatch()

  const [sidedarCollapsedWithActiveSearch, setSidedarCollapsedWithActiveSearch] =
    useState<boolean>()
  const searchQuery = useAppSelector(state => state.projectsSidebar.searchQuery)
  const searchActive = useAppSelector(state => state.projectsSidebar.searchActive)

  const changeSidebarSearchQuery = useCallback(
    (query: string) => {
      dispatch(projectsSidebar.actions.changeSearchQuery(query))
    },
    [dispatch],
  )

  const changeSidebarSearchActive = useCallback(
    (active: boolean) => {
      dispatch(projectsSidebar.actions.changeSearchActive(active))

      if (active && collapsed) {
        setSidedarCollapsedWithActiveSearch(true)
        toggleCollapseSidebar()
      }
      if (!active && !collapsed && sidedarCollapsedWithActiveSearch) {
        setSidedarCollapsedWithActiveSearch(false)
        toggleCollapseSidebar()
      }

      if (!active) {
        dispatch(projectsSidebar.actions.changeSearchQuery(''))
      }
    },
    [collapsed, dispatch, sidedarCollapsedWithActiveSearch, toggleCollapseSidebar],
  )

  const toggleCollapseSidebarAction = useCallback(() => {
    if (!sidedarCollapsedWithActiveSearch) {
      toggleCollapseSidebar()
    }
  }, [sidedarCollapsedWithActiveSearch, toggleCollapseSidebar])

  const onSelect = useCallback(() => {
    if (sidedarCollapsedWithActiveSearch) {
      changeSidebarSearchActive(false)
    }
  }, [changeSidebarSearchActive, sidedarCollapsedWithActiveSearch])

  useEffect(() => {
    if (collapsed && searchActive) {
      changeSidebarSearchActive(false)
    }
  }, [changeSidebarSearchActive, collapsed, searchActive])

  return {
    searchQuery,
    searchActive,
    changeSidebarSearchQuery,
    changeSidebarSearchActive,
    toggleCollapseSidebarAction,
    onSelect,
  }
}
